import api from './api';

export type PermissoesMap = Record<string, string[]>;

const permissoesService = {
  getAll: () => api.get<PermissoesMap>('/admin/permissions'),
  updateRole: (role: string, permissions: string[]) =>
    api.put<PermissoesMap>(`/admin/permissions/${role}`, { permissions }),
  getMyPermissions: () => api.get<{ permissions: string[] }>('/auth/me/permissions'),
};

export default permissoesService;
